import { useState, useEffect } from "react";
import style from './Booking.module.scss'
import Calendar from "components/Booking/Calendar/Calendar";
import Offcanvas from 'components/miscellaneous/Offcanvas/Offcanvas'
import AddEditAppointment from "components/Booking/AddEditAppointment/AddEditAppointment";
import Modal from "components/miscellaneous/Modal/Modal";
import DeleteAppointment from "components/Booking/DeleteAppointment/DeleteAppointment";
import api from "helpers/api";
import ClientUrlBrief from "components/Booking/ClientUrlBrief/ClientUrlBrief";

const Booking = () => {
    const [ addBooking, setAddBooking ] = useState(false)
    const [ editBooking, setEditBooking ] = useState(null)
    const [ refreshBookings, setRefreshBookings ] = useState(false)
    const [ deleteModal, setDeleteModal ] = useState(false);

    const showCanvas = () => {
        return addBooking !== false || editBooking !== null;
    }

    const closeCanvas = () => {
        setAddBooking(false);
        setEditBooking(null);
        setRefreshBookings(true)
    }

    const renderCanvas = () => {
        if (addBooking) {
            return <AddEditAppointment close={ closeCanvas } />
        } else if (editBooking) {
            return <AddEditAppointment close={ closeCanvas } appointment={ editBooking } doDelete={ setDeleteModal } />
        }
    }

    const updateBooking = async (booking) => {
        try {
            await api.patch(`/booking/${booking.token}`, {
                ...booking
            });
        } catch (e) {
            console.error(e)
        } finally {
            setRefreshBookings(true)
        }
    }

    useEffect(() => {
        if (refreshBookings === true) {
            setRefreshBookings(false)
        }
    }, [ refreshBookings ])

    return (<>
        <Offcanvas show={ showCanvas() } onClose={ () => {
            setAddBooking(false)
            setEditBooking(null)
        } } content={ renderCanvas() } sticky={ deleteModal === false ? false : true } />
        <Modal content={ <DeleteAppointment close={ (state) => {
            setDeleteModal(false)
            if (state === true) {
                closeCanvas()
            }
        } } appointment={ deleteModal } /> }
            modalStyle={ {
                position: 'relative'
            } }
            onClose={ (e) => {
                setDeleteModal(false)
            } }
            visible={ deleteModal }
        />
        <div className={ style.container }>
            <div className={ style.card }>
                <div className={ style.cardHeader }>
                    <h3>Booked Appointments</h3>
                    <div style={ { marginLeft: 'auto' } }>
                        <button onClick={ (e) => {
                            setAddBooking(true)
                        } } className='alma-button'>
                            Add Appointment
                        </button>
                    </div>
                </div>
                <div className={ style.cardBody }>
                    <Calendar doRefresh={ refreshBookings } onEventClick={ (e) => {
                        setEditBooking(e)
                    } } updateBooking={ updateBooking } />
                    {/* <AppointmentTable /> */ }
                </div>
            </div>

            <div className={ style.card }>
                <div className={ style.cardBody }>
                    <ClientUrlBrief />
                </div>
            </div>

            {
                /*
                    <div className={ style.card }>
                        <div className={ style.cardHeader }>
                            <h3>Services</h3>
                        </div>
                        <div className={ style.cardBody }>

                        </div>
                    </div>
                */
            }
        </div>
    </>)
}

export default Booking